import { jsx } from 'react/jsx-runtime';
function ShareLinkSvg({
  width = '12',
  height = '12',
  className,
  children
}) {
  return /*#__PURE__*/jsx("svg", {
    width: width,
    height: height,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: children
  });
}
export { ShareLinkSvg };
//# sourceMappingURL=ShareLinkSvg.js.map
